import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit,EventEmitter,Output} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { ProyectosService } from '../../services/proyectos.service';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-project-remove',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css'
})

// @Component({
//   selector: 'app-confirm-dialog',
//   standalone: true,
//   imports: [],
//   templateUrl: './confirm-dialog.component.html',
//   styleUrl: './confirm-dialog.component.css'
// })
export class ConfirmDialogComponent {
  title: string;
  texto: string;
  texto_confirmar: string = "Ok"
  texto_cancelar: string = "Cancel"
  buttonText: string = 'Copy Text';
  buttonImage: string = '';
  buttonTextColor: string = '#EEA21A'; // Color inicial

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    public proyectoService: ProyectosService
  ) {
    this.title = data.title;
    this.texto = data.texto;
    this.texto_confirmar = data.texto_confirmar || "Ok";
    this.texto_cancelar = data.texto_cancelar;
  }

  confirmar(){
      this.dialogRef.close(true);
  }

  cancelar(){
      this.dialogRef.close(false);
  }
}
